import { useOktaAuth } from "@okta/okta-react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { UserApplicationActions } from "./model";

export const UserApplicationController = (userId) => {
  const { authState } = useOktaAuth();
  const dispatch = useDispatch();

  let columns = [];
  let data = [];

  const userAccessHistory = useSelector(
    (rootState) => rootState.userAccessHistories.userAccessHistories[userId]
  );
  if (userAccessHistory) {
    data = userAccessHistory.value.data;
    columns = userAccessHistory.value.columns;
  }

  useEffect(() => {
    if (authState.isAuthenticated) {
      dispatch(
        UserApplicationActions.getUserAccessHistory({
          userId: userId,
        })
      );
    }
  }, [dispatch, authState, userId]);

  return {
    data,
    columns,
    isLoading: !!userAccessHistory?.progress,
  };
};
